<template>
  <div class="page-content home">
    <div class="inner-content">

      <div class="slider-wrapper">
        <headercomponent ref="header"></headercomponent>
        <div class="slider">
          <div
            v-for="(image, index) in sliderImages"
            :key="index"
            :class="`item item${index+1}`"
            :style="{ backgroundImage: `url('${cUrl_part_1}${screenSize}${cUrl_part_2}${image}')`}"
            >
          </div>
        </div>
        <a href="javascript:void(0);" id="scrolldown" v-scroll-to="{
          container: 'body',
          el:'.atelier',
          duration: 1500,
          easing: [.66,.18,.31,.99]
          }">
          <img src="/static/icons/arrow_bot.svg" alt="scroll down">
        </a>
      </div>

      <section class="atelier" v-if="atelierReady">
        <div class="container">
          <div class="header-thing">
            <h3 class="title">{{ $t('Atelier') }}</h3>
            <div class="lead"><p v-html="atelier.content.rendered"></p></div>
            <a href="javascript:void(0);" class="more-info" @click="showAtelier(!atelierShown);">
              <div></div>
              <div></div>
            </a>
          </div>
          <div class="content" v-if="philoReady">
            <transition @enter="sectionEnter" @leave="sectionLeave" appear>
              <div class="philosophie header-thing" v-show="philoReady && atelierShown">
                <h5 class="title" v-html="philo.title.rendered"></h5>
                <div class="rich-content" v-html="philo.content.rendered"></div>
              </div>
            </transition>
          </div>
        </div>
      </section>

      <FigaroVideo>

      </FigaroVideo>

      <FeaturedProject
        v-if="dataLoaded"
        :project="featuredprojects[0]"
      />

      <section class="equipe" v-if="pageEquipeReady && collaborateursLoaded">
        <div class="container">
          <h3 class="title">{{ $t('Equipe') }}</h3>
          <div class="lead"><p v-html="equipe.content.rendered"></p></div>

          <div class="middle">
            <div class="pics">
              <div class="owners">
                <Collaborateur
                v-for="(collaborator, i) in firstTwoCollaborators"
                :key="i"
                :collaborator="collaborator"
                />
              </div>
              <GroupPhoto :equipeData="equipe.acf" />
            </div>
            <div class="btn-wrapper">
                <a href="javascript:void(0);" class="more-info" @click="showTeam(!teamShown)">
                  <div></div>
                  <div></div>
                </a>
                <span v-if="equipe.acf.texte_du_bouton" v-html="equipe.acf.texte_du_bouton"></span>
            </div>
          </div>
          <div class="content">
            <transition @enter="sectionEnter" @leave="sectionLeave" appear>
              <div v-show="teamShown">
                <div class="collaborateurs">
                  <Collaborateur
                    v-for="(collaborator, i) in restOfCollaborators"
                    :key="i + 2"
                    :collaborator="collaborator"
                  />
                </div>
              </div>
            </transition>
          </div>
        </div>
      </section>

      <FeaturedProject
        v-if="dataLoaded"
        :project="featuredprojects[1]"
        :isOdd="true"
      />

    </div>
  </div>
</template>

<script>
import { TweenMax, TimelineMax, Power4, Expo } from 'gsap';
import { api } from '@/axios-config';
import VueScrollTo from 'vue-scrollto';
import HeaderComponent from '@/components/Modules/HeaderComponent';
import FeaturedProject from '@/components/Modules/FeaturedProject';
import FigaroVideo from '@/components/Modules/FigaroVideo';
import Collaborateur from '@/components/Modules/Collaborateur';
import GroupPhoto from '@/components/Modules/GroupPhoto';
import debounce from 'lodash/debounce';
import store from '@/store/store';

export default {
  name: 'Home',
  data() {
    return {
      cUrl_part_1: 'https://res.cloudinary.com/dfrhbuipn/image/upload/w_',
      cUrl_part_2: ',f_auto,dpr_2/v1541424180/',
      screenSize: '1000',
      sliderImages: [],
      collaborateurs: [],
      featuredprojects: [],
      philo: null,
      philoReady: false,
      equipe: null,
      pageEquipeReady: false,
      atelier: null,
      atelierReady: false,
      dataLoaded: false,
      collaborateursLoaded: false,
      tl: new TimelineMax({ repeat: -1, repeatDelay: -2 }),
      resizeHandler: null,
    };
  },
  components: {
    headercomponent: HeaderComponent,
    FeaturedProject,
    FigaroVideo,
    Collaborateur,
    GroupPhoto,
  },
  created() {
    this.getHomeSliderImages();
    this.getCollaborateurs();
    this.getProjects();
    this.getAtelier();
    this.getPhilosophie();
    this.getEquipe();
    this.getScreenSize();
  },
  mounted() {
    const that = this;
    store.commit('menuToggle', 'close');
    store.commit('showAtelier', false);
    store.commit('showTeam', false);
    setTimeout(() => {
      that.revealStuff();
    }, 400);
    // if clicked on a scroll link in the menu, from another page
    if (this.scrolltoElement != null) {
      this.waitAndScroll(this.scrolltoElement);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    sectionEnter(el, done) {
      const tl = new TimelineMax();
      tl.to(el.parentElement.parentElement.querySelector('.more-info'), 0.2, { rotation: 45, ease: Expo.easeInOut }, 0);
      tl.set(el, { y: -1500, autoAlpha: 0 }, 0);
      tl.set(el.parentElement, { height: 0 }, 0);
      tl.to(el.parentElement, 0.8, { height: el.clientHeight + 65, ease: Expo.easeInOut }, 0.3);
      tl.set(el, { y: -el.clientHeight, autoAlpha: 0 }, 0.3);
      tl.to(el, 0.8, { y: 0, autoAlpha: 1, ease: Expo.easeInOut, onComplete: done }, 0.3);

      window.addEventListener('resize', this.resizeHandler);
    },
    sectionLeave(el, done) {
      const tl = new TimelineMax();
      tl.to(el.parentElement.parentElement.querySelector('.more-info'), 0.2, { rotation: 0, ease: Expo.easeInOut }, 0);
      tl.set(el, { y: 0, autoAlpha: 1 }, 0);
      tl.set(el.parentElement, { height: el.clientHeight + 65 }, 0);
      tl.to(el, 0.8, { y: -el.clientHeight, autoAlpha: 0, ease: Expo.easeInOut }, 0.3);
      tl.to(el.parentElement, 0.8, { height: 0, ease: Expo.easeInOut, onComplete: done }, 0.3);

      window.removeEventListener('resize', this.resizeHandler);
    },
    waitAndScroll(element) {
      setTimeout(() => {
        VueScrollTo.scrollTo(element, {
          container: 'body',
          easing: 'cubic-bezier(0.6, 0.06, 0.27, 1)',
          duration: 1500,
        });
        store.commit('scrolltoElement', null);
      }, 500);
      setTimeout(() => {
        document.querySelector(`${element} .more-info`).click();
      }, 1000);
    },
    revealStuff() {
      const revealDivs = document.querySelectorAll('.home section, .home .featured-project');
      /* eslint-disable-next-line */
      for (const div of revealDivs) {
        this.$sr.reveal(div, { delay: 50, duration: 1500, easing: 'cubic-bezier(0.2, 0.94, 0.11, 1)', scale: 1, opacity: 0, distance: '100px' });
      }
    },
    getScreenSize() {
      const desiredSize = window.innerWidth;
      const sizes = [600, 750, 1000, 1500, 2000];
      let result = sizes.filter(number => number > desiredSize);
      if (result === undefined || result.length === 0) {
        result = [2000];
      }
      this.screenSize = String(this.closestNumber(result, desiredSize));
    },
    animate(x) {
      let tl = this.tl;
      const item1 = document.querySelector('.item1');
      const item2 = document.querySelector('.item2');
      const item3 = document.querySelector('.item3');
      const item4 = document.querySelector('.item4');
      const that = this;
      function anim(element) {
        const item = element;
        const tl2 = new TimelineMax();
        tl2.set(item, { xPercent: -100 }, '+=0');
        tl2.set(item, { zIndex: 1 }, '+=0');
        tl2.set(item, { zIndex: 2 }, '+=0.0001');
        tl2.to(item, 3, { xPercent: 0, rotation: 0.001, ease: Power4.easeInOut }, '+=0');
        tl2.set(item, { zIndex: 1 }, '+=2');
        tl2.set(item, { xPercent: -100 }, '+=3');
        return tl2;
      }
      if (x === 'delete') {
        // when leaving, destroy the animation completely
        tl.call(that.homeSlider, [false], that, 0);
        tl.kill();
        tl = null;
      } else {
        const items = [item1, item2, item3, item4];
        for (let i = 0; i < 6; i++) {
          items.forEach((item, index) => {
            tl.add(anim(item), i * 20 + index * 5);
          });
        }
      }
    },
    getHomeSliderImages() {
      api
        .get(`pages/216`)
        .then(response => {
          // this.sliderImages = response.data.acf.galerie;
          response.data.acf.galerie.forEach(element => {
            const nameOfImageCloudinary = element.url.split('/').pop();
            this.sliderImages.push(nameOfImageCloudinary);
          });
        })
        .catch(error => {
          console.error(`😱😱😱 getPage error: ${error}`);
        });
    },
    homeSlider(payload) {
      store.commit('homeSlider', payload);
    },
    swapLanguages() {
      const that = this;
      const tl = new TimelineMax();
      tl.to('footer', 0.5, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.to('#menu-wrapper', 0.5, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.to('.page-content', 0.5, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.add(() => {
        store.commit('showAtelier', false);
        store.commit('showTeam', false);
        store.commit('menuToggle', 'close');
        window.scroll(0, 1);
        that.getHomeSliderImages();
        that.getProjects();
        that.getAtelier();
        that.getPhilosophie();
        that.getEquipe();
      }, 0.5);
      tl.to('footer', 0.6, { autoAlpha: 1, ease: Power4.easeOut }, 1);
      tl.to('#menu-wrapper', 0.6, { autoAlpha: 1, ease: Power4.easeOut }, 1);
      tl.to('.page-content', 0.6, { autoAlpha: 1, ease: Power4.easeOut }, 1);
    },
    getCollaborateurs() {
      this.collaborateursLoaded = false;
      api
        .get(`collaborateurs`)
        .then(response => {
          this.collaborateurs = response.data;
          this.collaborateursLoaded = true;
        })
        .catch(error => {
          console.error(`Load collaborateurs error 😱😱😱: ${error}`);
        });
    },
    getProjects() {
      // vedette: 19
      // francais: 30
      // allemand: 32
      this.featuredprojects = [];
      this.dataLoaded = false;
      let category = '30';
      if (this.currentlang === 'de') {
        category = '32';
      }
      api
        .get(`projet?categories=${category}`)
        .then(response => {
          response.data.forEach(project => {
            if (project.categories.includes(19)) {
              this.featuredprojects.push(project);
            }
          });
          this.dataLoaded = true;
        })
        .catch(error => {
          console.error(`Load projects error 😱😱😱: ${error}`);
        });
    },
    getAtelier() {
      this.atelierReady = false;
      let pageToGet;
      if (this.currentlang === 'de') {
        pageToGet = 85;
      } else {
        pageToGet = 11;
      }
      api
        .get(`pages/${pageToGet}`)
        .then(response => {
          this.atelier = response.data;
          this.atelierReady = true;
        })
        .catch(error => {
          console.error(`😱😱😱 getPage error: ${error}`);
        });
    },
    getPhilosophie() {
      this.philoReady = false;
      let pageToGet;
      if (this.currentlang === 'de') {
        pageToGet = 89;
      } else {
        pageToGet = 13;
      }
      api
        .get(`pages/${pageToGet}`)
        .then(response => {
          this.philo = response.data;
          this.philoReady = true;
        })
        .catch(error => {
          console.error(`😱😱😱 getPage error: ${error}`);
        });
    },
    getEquipe() {
      this.pageEquipeReady = false;
      let pageToGet;
      if (this.currentlang === 'de') {
        pageToGet = 158;
      } else {
        pageToGet = 156;
      }
      api
        .get(`pages/${pageToGet}`)
        .then(response => {
          this.equipe = response.data;
          this.pageEquipeReady = true;
        })
        .catch(error => {
          console.error(`😱😱😱 getPage error: ${error}`);
        });
    },
    slugExtraction(item) {
      return `/projets/${item.slug}`;
    },
    /* eslint-disable-next-line */
    closestNumber: function(array, num) {
      let minDiff = 1000;
      let ans;

      array.forEach(value => {
        const diff = Math.abs(num - value);
        if (diff < minDiff) {
          minDiff = diff;
          ans = value;
        }
      });

      return ans;
    },
    showAtelier(value) {
      store.commit('showAtelier', value);
    },
    showTeam(value) {
      store.commit('showTeam', value);
      if (value === true) {
        this.adjustHeightOnResize();
      } else {
        window.removeEventListener('resize', this.resizeHandler);
      }
    },
    adjustHeightOnResize() {
      const adjustHeight = () => {
        if (this.teamShown) {
          const el = this.$el.querySelector('.equipe .content > div');
          const content = this.$el.querySelector('.equipe .content');
          if (el && content) {
            content.style.height = '';
            TweenMax.to(content, {
              height: el.clientHeight + 65,
              duration: 0.8,
              ease: Expo.easeInOut,
            });
          }
        }
      };
      this.resizeHandler = debounce(adjustHeight, 200);
      adjustHeight();
    },
  },
  computed: {
    scrolltoElement() {
      return store.state.scrolltoElement;
    },
    homeslideractive() {
      return store.state.homeSlider;
    },
    currentlang() {
      return store.state.i18n.locale;
    },
    atelierShown() {
      return store.state.atelierShown;
    },
    teamShown() {
      return store.state.teamShown;
    },
    firstTwoCollaborators() {
      return this.collaborateurs.slice(0, 2);
    },
    restOfCollaborators() {
      return this.collaborateurs.slice(2);
    },
  },
  watch: {
    homeslideractive() {
      if (this.homeslideractive) {
        this.animate();
      } else {
        this.animate('delete');
      }
    },
    currentlang() {
      this.swapLanguages();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';
// =====================================================
// Top part
// =====================================================
.slider-wrapper {
  height: 100vh;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.slider {
  height: 100%;
  width: 100%;
}
.item {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  // trying some random css fixes for firefox
  will-change: transform;
  transform: translateZ(0);
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000;
}
#scrolldown {
  position: absolute;
  bottom: 2%;
  left: 50%;
  transform: translateX(-50%);
  height: 50px;
  width: 50px;
  z-index: 10;
  animation: opacityPulse 3s infinite;
  img {
    height: 100%;
    width: 100%;
  }
  @include sm {
    height: 35px;
    width: 35px;
  }
}
@keyframes opacityPulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
// =====================================================
// sections
// =====================================================
section {
  position: relative;
  .content {
    overflow: hidden;
  }
}
.header-thing {
  display: flex;
  .title {
    width: 33.33333333%;
  }
  .lead {
    width: 58.33333333%;
  }
  .more-info {
    position: absolute;
    right: 20%;
    top: 96px;
    transition: transform 0.2s ease;
    width: 23px;
    height: 23px;
    cursor: pointer;
    div {
      background-color: black;
      position: absolute;
      &:nth-child(1) {
        width: 100%;
        height: 1px;
        top: 11px;
      }
      &:nth-child(2) {
        width: 1px;
        height: 100%;
        left: 11px;
      }
    }
  }
  @include xxl {
    flex-wrap: wrap;
    .title {
      width: 33.33333333%;
    }
    .lead {
      width: 66.66666666%;
    }
    .more-info {
      position: relative;
      display: block;
      top: auto;
      right: auto;
      margin-left: 33.33333333%;
      margin-top: 30px;
    }
  }
  @include md {
    .title {
      width: 25%;
    }
    .lead {
      width: 70%;
    }
    .more-info {
      margin-left: 25%;
    }
  }
  @include xs {
    flex-direction: column;
    .title {
      width: 100%;
      margin-bottom: 15px;
    }
    .lead {
      width: 100%;
    }
    .more-info {
      margin-left: 0%;
    }
  }
}
// =====================================================
// Philosophie
// =====================================================
.philosophie {
  margin-top: 35px;
  .rich-content {
    width: calc((100% / 3) * 2);
    margin-bottom: -15px;
  }
  @include sm {
    margin-top: 20px;
  }
  @include xs {
    margin-top: 15px;
    .rich-content {
      width: 100%;
    }
  }
}
// =====================================================
// equipe
// =====================================================
.equipe {
  .title {
    margin-bottom: 45px;
  }
  .middle {
    margin: 45px 0;
    display: flex;
    flex-wrap: wrap;
    gap: 45px;
    .pics {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-template-rows: auto;
      gap: 45px;
      flex: 1;
    }
    .owners {
      display: flex;
      gap: 45px;
      grid-column: span 6;
      align-items: flex-end;
    }
    .collaborateur {
      flex-shrink: 0;
      flex: 1;
      min-width: 200px;
    }
    .group-photo {
      grid-column: span 6;
    }
    @include lg {
      flex-direction: column;
      flex-wrap: nowrap;
      .pics {
        gap: 35px;
      }
      .owners {
        flex-direction: column;
        align-items: stretch;
        gap: 35px;
        grid-column: span 4;
      }
      .group-photo {
        grid-column: span 8;
      }
    }
    @include md {
      .pics {
        gap: 20px;
      }
      .owners {
        grid-row-start: 2;
        flex-direction: row;
        grid-column: span 12;
        gap: 20px;
      }
      .group-photo {
        grid-column: span 12;
      }
    }
    @include sm {
      .owners {
        gap: 15px;
        flex-direction: column;
      }
    }
  }
}
.btn-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  .more-info {
    position: relative;
    display: block;
    transition: transform 0.2s ease;
    width: 23px;
    height: 23px;
    cursor: pointer;
    div {
      background-color: black;
      position: absolute;
      &:nth-child(1) {
        width: 100%;
        height: 1px;
        top: 11px;
      }
      &:nth-child(2) {
        width: 1px;
        height: 100%;
        left: 11px;
      }
    }
  }
}
.collaborateurs {
  margin: 65px 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 50px;
  @include xl() {
    margin: 20px 0;
    grid-template-columns: repeat(3, 1fr);
  }
  @include lg {
    gap: 35px;
  }
  @include md {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  @include sm {
    grid-template-columns: repeat(2, 1fr);
  }
  @include xs {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue